/* Fabriqué par shopify/native/construire.cjs depuis features/club : ne pas modifier ici. */
(function(){
function creerLectureClub(port){return {charger:function(){return port.charger();}};}

function creerModeleClub(application,connectee,publier){
 var etat={fiche:null,ouvert:false};
 function charger(){return application.charger().then(function(d){if(d){etat.fiche=d;publier();}return d;});}
 return {etat:function(){return etat;},charger:charger,
  ouvrir:function(){etat.ouvert=true;publier();if(connectee)charger();},
  fermer:function(){etat.ouvert=false;}
 };
}

function monterClub(document,window,D,application) {
  'use strict';

  // Le calcul, la mise en forme de l'argent et la demande au serveur sont dans
  // `oraloa-tiki-donnees`, rendu juste au-dessus. Ce fichier-ci ne fait que
  // dessiner : c'est ce qui garantit que la page du club et cette fenêtre
  // affichent le même nombre d'euros, au centime près.

  var pts = D.pts, euros = D.euros, texte = D.texte, image = D.image, imageBadge = D.imageBadge;
  var M = D.mot, P = D.phrase;
  var PAGE = D.liens.page, BADGES = D.liens.badges, CONNEXION = D.liens.connexion;
  var INSCRIPTION = D.liens.inscription || CONNEXION;
  var CONNECTE = D.connectee;

  var panneau = document.getElementById('otc-panneau');
  var zoneQui = document.getElementById('otc-qui');
  var zone    = document.getElementById('otc-contenu');
  if (!panneau) return;

  var modele=creerModeleClub(application,CONNECTE,dessiner);        // la réponse, gardée pour la durée de la visite
  var rendu = null;        // l'élément qui avait le curseur avant l'ouverture

  // ── les morceaux de la fenêtre
  function enTete(f) {
    if (!f || !f.membre) return '';
    var niveau = f.niveau || {};
    return '<span class="otc-av">' +
             imageBadge(niveau.image, 128, '') +
           '</span>' +
           '<div><b>' + texte(f.nom || M('bonjour')) + '</b>' +
           (niveau.libelle ? '<small>' + M('membre_du_club') + '</small>' : '') + '</div>' +
           (niveau.libelle ? '<span class="otc__lvl">★ ' + texte(niveau.libelle) + '</span>' : '');
  }

  function carte(f) {
    var h = '<div class="otc__card">' +
            '<img src="' + image('coffre.png', 256) + '" alt="" width="58" loading="lazy">' +
            '<div><small>' + M('mes_points') + '</small>' +
            '<b>' + pts(f.solde) + '<span>pts</span></b>';
    // Un solde qui ne vaut pas encore un euro entier : on ne promet pas « 0 € ».
    if (f.soldeEnEuros > 0) {
      h += '<em>' + M('solde_en_remise', { n: euros(f.soldeEnEuros * 100) }) + '</em>';
    }
    return h + '</div></div>';
  }

  function prochaine(f) {
    var r = f.recompenseProchaine;
    // Plus rien à atteindre : elle a de quoi prendre la plus grosse remise. On
    // ne laisse pas un vide, on le lui dit.
    if (!r) {
      return f.recompenseDisponible
        ? '<div class="otc__next" style="color:#1f6b45;font-weight:800">' +
          M('tout_a_portee') +
          '<div class="otc-bar"><i style="width:100%"></i></div></div>'
        : '';
    }
    var atteint = Number(r.points) - Number(r.manque);
    var part = r.points > 0 ? Math.max(Math.min(atteint / r.points, 1), 0) : 0;
    var deja = f.recompenseDisponible;
    return '<div class="otc__next">' +
           M('encore_pour', { a: pts(r.manque), b: euros(r.valeurEur) }) +
           '<div class="otc-bar"><i style="width:' + (part * 100).toFixed(1) + '%"></i></div>' +
           '<div class="otc-ends"><span>' +
             (deja ? M('debloques', { n: euros(deja.valeurEur) })
                   : M('premiere_remise', { n: pts(r.points) })) +
           '</span><span>' + euros(r.valeurEur) + ' · ' + pts(r.points) + ' ' + M('pts') +
           '</span></div></div>';
  }

  function recompenses(f) {
    var liste = f.recompenses || [];
    if (!liste.length) return '';
    var h = '<div><h4>' + M('debloquer') + ' <a href="' + PAGE + '">' + M('tout_voir') +
            '</a></h4><div class="otc-rw">';
    liste.forEach(function (r) {
      h += '<div class="otc-r ' + (r.disponible ? 'is-ok' : 'is-lock') + '">' +
           '<b>' + euros(r.valeurEur) + '<small>' + M('de_remise') + '</small></b>' +
           '<span class="otc-p">' + pts(r.points) + ' points</span>' +
           (r.disponible
              ? '<span class="otc-ready">' + M('a_prendre') + '</span>'
              : '<span class="otc-lk">' + M('encore_pts', { n: pts(r.manque) }) + '</span>') +
           '</div>';
    });
    return h + '</div></div>';
  }

  function badges(f) {
    var b = f.badges || { familles: [] };
    var tous = [];
    (b.familles || []).forEach(function (fam) { tous = tous.concat(fam.badges || []); });
    if (!tous.length) return '';
    // UNE PASTILLE NON GAGNÉE NE S'AFFICHE PAS.
    //
    // Haïm Hamelekh, le 3 octobre 2026 : « pour les badges, ils doivent même pas
    // être en noir et blanc mais cachés si non gagnés. » Ici se trouve donc la
    // collection de la cliente, et rien d'autre : ce qu'il reste à gagner est
    // sur la page des pastilles, en couleurs.
    var obtenus = tous.filter(function (x) { return x.obtenu; });
    if (!obtenus.length) return '';
    var montres = obtenus.slice(0, 6);
    var h = '<div><h4>' + M('mes_badges', { a: b.obtenus, b: b.total }) +
            ' <a href="' + BADGES + '">' + M('tous_les_badges') + '</a></h4><div class="otc__badges">';
    montres.forEach(function (x) {
      var nom = P(x.nomVisible);
      h += '<span class="otc-bd' + (x.obtenu ? '' : ' is-off') + '" title="' + texte(nom) +
           '" data-tuile>' + imageBadge(x.image, 128, nom) + '</span>';
    });
    // « +3 », c'est trois badges À ELLE qu'on n'a pas la place de montrer. Le
    // nombre de badges restant à gagner est déjà dit juste au-dessus, et
    // mélanger les deux ferait croire qu'elle en a 69.
    var caches = (obtenus.length ? obtenus.length : tous.length) - montres.length;
    if (caches > 0) h += '<a class="otc-more" href="' + BADGES + '">+' + caches + '</a>';
    return h + '</div></div>';
  }

  function mouvements(f) {
    var m = f.derniersMouvements || [];
    if (!m.length) return '';
    var h = '<div><h4>' + M('derniers_points') + '</h4><div class="otc__moves">';
    m.slice(0, 5).forEach(function (x) {
      var plus = Number(x.points) > 0;
      h += '<div><span>' + texte(x.libelle) + '</span>' +
           '<b class="' + (plus ? 'is-plus' : '') + '">' + (plus ? '+' : '') + pts(x.points) + '</b></div>';
    });
    return h + '</div></div>';
  }

  function message(titre, corps, bouton, lien) {
    return '<div class="otc__mid"><b>' + texte(titre) + '</b>' + texte(corps) +
           (bouton ? '<br><a class="otc-btn otc-btn--carib otc-btn--sm" href="' + lien + '">' + texte(bouton) + '</a>' : '') +
           '</div>';
  }

  //: Les quatre raisons de s'inscrire, et rien que des vraies.
  //:
  //: Le niveau « Tiki Découverte » annonce aussi « 500 points de bienvenue »,
  //: et AUCUN code ne les donne : ce serait une promesse en l'air, sur de
  //: l'argent. Elle n'est donc pas ici tant que personne ne l'a écrite.
  var RAISONS = [
    ['inv_1', 'inv_1_t', 'M12 .6 14.5 9.5 23.4 12 14.5 14.5 12 23.4 9.5 14.5.6 12 9.5 9.5Z'],
    ['inv_2', 'inv_2_t', 'M12 1.5 15 8l7 .6-5.3 4.6 1.6 6.8L12 16.4 5.7 20l1.6-6.8L2 8.6 9 8Z'],
    ['inv_3', 'inv_3_t', 'M3 3h18v14H8l-5 4Z'],
    // Le calendrier : deux formes dans un seul chemin, creusées par
    // `fill-rule=evenodd`. Sans cette règle, le cadre se remplit en bloc et
    // l'icône devient un carré plein.
    ['inv_4', 'inv_4_t', 'M7 1h2v2h6V1h2v2h3v20H4V3h3Zm13 7H4v13h16Z']
  ];

  function invitation() {
    var h = '<div class="otc__inv"><h3>' + texte(M('inv_titre')) + '</h3>'
          + '<p class="otc__inv-s">' + texte(M('inv_sous')) + '</p>'
          + '<div class="otc__inv-cadeau"><b>' + texte(M('inv_0')) + '</b>'
          + '<span>' + texte(M('inv_0_t')) + '</span></div><ul>';
    for (var i = 0; i < RAISONS.length; i++) {
      var r = RAISONS[i];
      h += '<li><span class="otc__inv-i"><svg viewBox="0 0 24 24" aria-hidden="true">'
         + '<path fill-rule="evenodd" d="' + r[2] + '"/></svg></span>'
         + '<span><b>' + texte(M(r[0])) + '</b><span>' + texte(M(r[1])) + '</span></span></li>';
    }
    return h + '</ul><div class="otc__inv-bas">'
         + '<a class="otc-btn otc-btn--carib" href="' + INSCRIPTION + '">'
         + texte(M('inv_creer')) + '</a>'
         + '<a class="otc-btn otc-btn--ghost otc-btn--sm" href="' + CONNEXION + '">'
         + texte(M('inv_deja')) + '</a></div>'
         + '<p class="otc__inv-note">' + texte(M('inv_gratuit')) + '</p></div>';
  }

  function dessiner() {
    var fiche=modele.etat().fiche;
    // « nu » veut dire : aucun nom, aucun niveau à montrer en haut. On ne le met
    // PAS pendant le chargement, sinon le bandeau se replie puis se redéplie
    // sous les yeux de la cliente.
    panneau.classList.toggle('otc--nu', !CONNECTE || (fiche != null && (fiche.erreur != null || fiche.membre === false)));
    if (!CONNECTE) {
      zoneQui.innerHTML = '';
      zone.innerHTML = invitation();
      return;
    }
    if (!fiche) {
      zoneQui.innerHTML = '';
      zone.innerHTML = '<div class="otc__card"><div style="flex:1"><div class="otc__skel" style="width:40%"></div>' +
                       '<div class="otc__skel" style="height:26px;margin-top:10px;width:70%"></div></div></div>' +
                       '<div class="otc__next"><div class="otc-bar"></div></div>';
      return;
    }
    if (fiche.erreur || fiche.membre === false) {
      zoneQui.innerHTML = '';
      zone.innerHTML = message(M('pas_membre'), M('pas_membre_texte'), M('decouvrir_club'), PAGE);
      return;
    }
    // « mon » Tiki Club : seulement pour une membre. Voir la note du pied.
    var lienClub = panneau.querySelector('[data-otc-lien-club]');
    if (lienClub) lienClub.textContent = M(fiche.membre ? 'voir_mon_club' : 'decouvrir_club');

    zoneQui.innerHTML = enTete(fiche);
    zone.innerHTML = carte(fiche) + prochaine(fiche) +
                     '<div class="otc__body">' + recompenses(fiche) + badges(fiche) + mouvements(fiche) + '</div>';
  }

  // ── la demande, une seule fois par visite, partagée avec la page du club ──
  function charger(){return modele.charger();}

  // ── ouvrir, fermer
  function ouvrir() {
    rendu = document.activeElement;
    panneau.hidden = false;
    panneau.classList.add('otc--on');
    document.documentElement.style.overflow = 'hidden';
    modele.ouvrir();
    // Une visiteuse non connectée voit une invitation à se connecter, et rien
    // d'autre : inutile d'aller chercher le catalogue pour une fenêtre qui ne
    // l'affichera pas. La page du Tiki Club, elle, le demande toujours.

    var fermer = panneau.querySelector('.otc__close');
    if (fermer) fermer.focus();
  }
  function fermer() {
    modele.fermer();
    panneau.classList.remove('otc--on');
    panneau.hidden = true;
    document.documentElement.style.overflow = '';
    if (rendu && rendu.focus) rendu.focus();
  }

  document.addEventListener('click', function (e) {
    var ouvre = e.target.closest('[data-tiki-club]');
    if (ouvre) {
      e.preventDefault();
      // (7 octobre 2026) connectée : la page du Tiki Club, tout droit ; le pop-up, seulement sinon
      if (D && D.connectee && PAGE) {
        if (window.location.pathname.replace(/\/$/, '') === String(PAGE).replace(/\/$/, '')) window.scrollTo(0, 0);
        else window.location.assign(PAGE);
        return;
      }
      ouvrir(); return;
    }
    if (e.target.closest('[data-otc-fermer]')) { e.preventDefault(); fermer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panneau.hidden) fermer();
  });

  // Le reste de la boutique peut s'en servir : `window.TikiClub.ouvrir()`.
  window.TikiClub = { ouvrir: ouvrir, fermer: fermer, charger: charger,
                      fiche: function () { return modele.etat().fiche; } };
}

monterClub(document,window,window.TikiDonnees,creerLectureClub(window.TikiDonnees));

/* LA CHASSE AU TIKI : la page où l'on est, écrite comme le serveur l'écrit.
   « /en/products/Forest-Cat/ » et « /products/forest-cat » sont la même page :
   un Tiki caché sur un kit se trouve dans les quatre langues. La même règle vit
   côté serveur (`tiki/modules/jeux/domain/reglesDuMoment.ts`). */
function cheminDuSite(brut) {
  var c = String(brut || '').trim();
  c = c.replace(/^[a-z]+:\/\/[^/]+/i, '').replace(/[?#].*$/, '').toLowerCase();
  try { c = decodeURIComponent(c); } catch (e) { /* on garde tel quel */ }
  c = c.replace(/\/{2,}/g, '/').replace(/^\/(fr|en|de|es)(?=\/|$)/, '');
  if (c.charAt(0) !== '/') c = '/' + c;
  if (c.length > 1) c = c.replace(/\/+$/, '');
  return c;
}
/* Le sel des empreintes, le même qu'au serveur : la page compare des empreintes,
   jamais des adresses. */
var SEL_CHASSE = 'oraloa-tiki-chasse:';

function creerTransportChasse(fetch, crypto, stockage){return {
 // la trouvaille part au serveur, qui vérifie les pages et tire le gain
 jouer:function(apport){return fetch('/apps/tiki-club?jouer=1',{method:'POST',credentials:'same-origin',
  headers:{'content-type':'application/json',accept:'application/json'},body:JSON.stringify(apport)})
  .then(function(r){return r.json();});},
 empreinte:function(texte){return crypto.subtle.digest('SHA-256',new TextEncoder().encode(texte)).then(function(b){
  return Array.prototype.map.call(new Uint8Array(b),function(x){return (x<16?'0':'')+x.toString(16);}).join('');});},
 lire:function(){try{return JSON.parse(stockage.getItem('oraloa-tiki-chasse')||'null');}catch(e){return null;}},
 ecrire:function(r){try{stockage.setItem('oraloa-tiki-chasse',JSON.stringify(r));}catch(e){/* sans stockage, rien ne casse */}}
};}

/* ═══════════ LA CHASSE AU TIKI, ET LES ŒUFS DE PÂQUES ═══════════

   « Un petit Tiki est caché quelque part sur le site. Elle doit le trouver. »

   Le pop-up du Club est présent sur toutes les pages : c'est donc lui qui sait
   montrer le Tiki sur la bonne. La page du Club a retenu, quand elle a lu
   l'énigme, les EMPREINTES des cachettes (jamais leurs adresses). Ici, on
   calcule l'empreinte de la page où l'on est ; si elle en fait partie, le Tiki
   apparaît au bord de l'écran.

   Le Tiki trouvé (ou le cinquième œuf), la partie part au serveur avec les pages
   trouvées. C'est lui qui vérifie, et qui tire le gain. */
function monterChasse(document, window, D, transport) {
  'use strict';
  var r = transport.lire();
  if (!D || !D.connectee || !r || !r.cachettes || !r.cachettes.length) return;
  // Trouvé aujourd'hui : le Tiki se repose jusqu'à demain, la chasse reprend alors à zéro.
  var aujourdhui = new Date().toISOString().slice(0, 10);
  if (r.fini === aujourdhui) return;
  if (r.fini) { r.fini = ''; r.trouves = []; }
  r.trouves = r.trouves || [];
  var chemin = cheminDuSite(window.location.pathname);
  if (r.trouves.indexOf(chemin) >= 0) return;
  var M = D.mot, texte = D.texte;
  var oeufs = Number(r.n) > 1;

  transport.empreinte(SEL_CHASSE + chemin).then(function (h) {
    if (r.cachettes.indexOf(h) >= 0) montrer(h);
  }, function () { /* sans chiffrement, la chasse ne se joue pas ici */ });

  function montrer(h) {
    var b = document.createElement('button');
    b.type = 'button';
    // le côté et la hauteur viennent de l'empreinte : toujours la même place sur cette page
    b.className = 'otc-chasse' + (parseInt(h.slice(0, 2), 16) % 2 ? ' est-droite' : '');
    b.style.top = (30 + parseInt(h.slice(2, 4), 16) % 45) + '%';
    b.setAttribute('aria-label', M(oeufs ? 'cal_oeuf' : 'cal_tiki'));
    b.textContent = oeufs ? '🥚' : '🗿';
    b.addEventListener('click', function () { trouver(b); });
    document.body.appendChild(b);
  }

  function trouver(b) {
    b.disabled = true;
    b.classList.add('est-trouve');
    if (r.trouves.indexOf(chemin) < 0) r.trouves.push(chemin);
    transport.ecrire(r);
    if (r.trouves.length < Number(r.n || 1)) {
      fenetre(oeufs ? '🥚' : '🗿', M('cal_oeuf_trouve', { n: Number(r.n) - r.trouves.length }), '');
      return;
    }
    transport.jouer({ trouve: r.trouves }).then(function (d) {
      if (d && d.ouvert && !d.refus && !d.erreur) { r.fini = aujourdhui; transport.ecrire(r); }
      if (d && d.ouvert && !d.refus && !d.dejaJoue && !d.erreur) {
        fenetre(oeufs ? '🐣' : '🌺', M(oeufs ? 'cal_oeufs_tous' : 'cal_chasse_trouve'), gain(d));
      } else {
        fenetre('🗿', (d && d.dejaJoue) ? M('moment_deja_jour') : M('moment_souci'), '');
      }
    }, function () { fenetre('🗿', M('moment_souci'), ''); });
  }

  function gain(d) {
    if (d.type === 'cadeau') return d.libelle || M('moment_gagne_cadeau');
    if (d.type === 'badge') return M('moment_gagne_badge');
    return M('moment_gagne_points', { n: D.pts(d.points) });
  }

  function fenetre(image, titre, sous) {
    var f = document.createElement('div');
    f.className = 'otc-chasse-pop';
    f.setAttribute('role', 'dialog');
    f.setAttribute('aria-modal', 'true');
    f.innerHTML = '<div class="otc-chasse-boite"><button type="button" class="otc__close" data-chasse-fermer aria-label="'
      + texte(M('fermer')) + '">&times;</button><div class="otc-chasse-ico" aria-hidden="true">' + image + '</div>'
      + '<b>' + texte(titre) + '</b>' + (sous ? '<p>' + texte(sous) + '</p>' : '')
      + '<a class="otc-btn otc-btn--rich" href="' + texte(D.liens.page) + '">' + texte(M('voir_mon_club')) + '</a></div>';
    f.addEventListener('click', function (e) {
      if (e.target === f || e.target.closest('[data-chasse-fermer]')) f.parentNode.removeChild(f);
    });
    document.body.appendChild(f);
    var x = f.querySelector('[data-chasse-fermer]');
    if (x) x.focus();
  }
}

monterChasse(document,window,window.TikiDonnees,creerTransportChasse(function(url,options){return fetch(url,options);},window.crypto,window.localStorage));
})();
